








import { Component, Prop, Vue } from 'vue-property-decorator'
import FranchiseReportTable from '@/pages/FranchiseReporting/FranchiseReportTable.vue'
import { UserSearch } from './types/user-search'


@Component({
    components: { FranchiseReportTable }
})
export default class GoogleTable extends Vue {
    @Prop() userSearch!: UserSearch

    headers = [
        { text: 'Location Name', align: 'left', value: 'name' },
        { text: 'Pulsem Account Id', value: 'pulsemAccountId' },
        { text: 'Begin Count', value: 'beginCount' },
        { text: 'End Count', value: 'endCount' },
        { text: 'Net Gain', value: 'netGain' },
        { text: 'Begin Rating', value: 'beginRating' },
        { text: 'End Rating', value: 'endRating' },
        { text: 'Review Velocity', value: 'reviewVelocity' },
        { text: 'Social Media Url', value: 'socialMediaUrl' },
        { text: 'Street', value: 'street' },
        { text: 'City', value: 'city' },
        { text: 'State', value: 'state' },
        { text: 'Country', value: 'country' },
        { text: 'Zipcode', value: 'zipcode' }
    ]
}
